var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account_box" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("礼金补贴活动管理")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt20",
          staticStyle: {
            background: "#fff",
            padding: "20px",
            "border-radius": "8px",
          },
        },
        [
          _c("div", { staticClass: "search_criteria" }, [
            _c(
              "div",
              { staticStyle: { "margin-left": "0" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "输入活动名称查询", clearable: "" },
                  model: {
                    value: _vm.queryData.activityName,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "activityName", $$v)
                    },
                    expression: "queryData.activityName",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "选择活动状态", clearable: "" },
                    model: {
                      value: _vm.queryData.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryData, "status", $$v)
                      },
                      expression: "queryData.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { value: 0, label: "未开始" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { value: 1, label: "进行中" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { value: 2, label: "已结束" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex",
                staticStyle: { width: "fit-content", height: "40px" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { height: "40px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.onInquire },
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "ml10",
                    staticStyle: { height: "40px" },
                    attrs: { type: "info", plain: "" },
                    on: { click: _vm.onInitialize },
                  },
                  [_vm._v("重置")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: { click: _vm.onAdd },
                  },
                  [_vm._v("新增+")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt20",
          staticStyle: {
            background: "#fff",
            padding: "20px",
            "border-radius": "8px",
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "header-cell-style": { "text-align": "center" },
                "cell-style": { "text-align": "center" },
                data: _vm.tableData,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "活动名称", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.activityName))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "头图", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                            },
                          },
                          [
                            _c("el-image", {
                              staticStyle: { display: "block", width: "50px" },
                              attrs: {
                                src: scope.row.headPic,
                                fit: "scale-down",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "用户类型", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.userTypeName))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "可参与次数", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.perLimit))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "活动时间", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.startTime))]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(scope.row.endTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "活动状态", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { style: { color: _vm.realObj[scope.row.status] } },
                          [_vm._v(_vm._s(scope.row.statusName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "创建时间", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.createTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.copy(scope.row)
                              },
                            },
                          },
                          [_vm._v("复制链接")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.detail(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.del(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "20px" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.queryData.size,
                  layout: "total, prev, pager, next, sizes,jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "3%",
            title: "活动" + (_vm.eventsType === "add" ? "添加" : "编辑"),
            visible: _vm.dialogVisible,
            width: "50%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _vm.dialogVisible
            ? _c(
                "div",
                { staticClass: "fc" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      staticStyle: { width: "90%" },
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "170px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动名称：", prop: "activityName" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.ruleForm.activityName,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "activityName", $$v)
                              },
                              expression: "ruleForm.activityName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-start",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-right": "50px" },
                              attrs: { label: "头图:", prop: "headPic" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    width: "130px",
                                    height: "130px",
                                    background: "#f9f9f9",
                                    "border-radius": "4px",
                                    border: "1px solid #eeeeee",
                                  },
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "avatar-uploader",
                                      attrs: {
                                        "show-file-list": false,
                                        action: "",
                                        "http-request": _vm.handleFileUpload,
                                      },
                                    },
                                    [
                                      _vm.ruleForm.headPic
                                        ? _c("el-image", {
                                            staticStyle: {
                                              width: "130px",
                                              height: "130px",
                                            },
                                            attrs: {
                                              "preview-src-list": [
                                                _vm.ruleForm.headPic,
                                              ],
                                              src: _vm.ruleForm.headPic,
                                              fit: "scale-down",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.look($event)
                                              },
                                            },
                                          })
                                        : _c("i", {
                                            staticClass:
                                              "el-icon-plus avatar-uploader-icon",
                                          }),
                                      _vm._v(" "),
                                      _vm.ruleForm.headPic
                                        ? _c("i", {
                                            staticClass: "el-icon-error",
                                            staticStyle: {
                                              position: "absolute",
                                              right: "-30px",
                                              top: "-10px",
                                              "font-size": "25px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                _vm.ruleForm.headPic = ""
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#F59A23",
                                    "font-size": "12px",
                                  },
                                },
                                [_vm._v("注：建议尺寸750px*320px")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "标签图:", prop: "tagPic" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    width: "130px",
                                    height: "130px",
                                    background: "#f9f9f9",
                                    "border-radius": "4px",
                                    border: "1px solid #eeeeee",
                                  },
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "avatar-uploader",
                                      attrs: {
                                        "show-file-list": false,
                                        action: "",
                                        "http-request": _vm.handleFileUpload1,
                                      },
                                    },
                                    [
                                      _vm.ruleForm.tagPic
                                        ? _c("el-image", {
                                            staticStyle: {
                                              width: "130px",
                                              height: "130px",
                                            },
                                            attrs: {
                                              "preview-src-list": [
                                                _vm.ruleForm.tagPic,
                                              ],
                                              src: _vm.ruleForm.tagPic,
                                              fit: "scale-down",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.look($event)
                                              },
                                            },
                                          })
                                        : _c("i", {
                                            staticClass:
                                              "el-icon-plus avatar-uploader-icon",
                                          }),
                                      _vm._v(" "),
                                      _vm.ruleForm.tagPic
                                        ? _c("i", {
                                            staticClass: "el-icon-error",
                                            staticStyle: {
                                              position: "absolute",
                                              right: "-30px",
                                              top: "-10px",
                                              "font-size": "25px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                _vm.ruleForm.tagPic = ""
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#F59A23",
                                    "font-size": "12px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "注：即商品主图左上角展示标签，建议尺寸74px*74px"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户类型：", prop: "userType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled:
                                  _vm.boole && _vm.eventsType === "upDate",
                              },
                              on: { change: _vm.typeChange },
                              model: {
                                value: _vm.ruleForm.userType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "userType", $$v)
                                },
                                expression: "ruleForm.userType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("所有人"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("已提现用户"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 4 } }, [
                                _vm._v("指定等级"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("新用户"),
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "10px" } },
                                  [_vm._v("（注册后未出单）")]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.ruleForm.userType === 4
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "等级：", prop: "userGrade" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择等级",
                                  },
                                  model: {
                                    value: _vm.ruleForm.userGrade,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "userGrade", $$v)
                                    },
                                    expression: "ruleForm.userGrade",
                                  },
                                },
                                _vm._l(_vm.greadOption, function (item) {
                                  return _c("el-option", {
                                    key: item.grade,
                                    attrs: {
                                      label: item.name,
                                      value: item.grade,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "每人限购次数：", prop: "perLimit" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                disabled: _vm.ruleForm.userType === 1,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.ruleForm.perLimit,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "perLimit",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "ruleForm.perLimit",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("次"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "同一商品可购买次数：",
                            prop: "goodsLimit",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                disabled: _vm.ruleForm.userType === 1,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.ruleForm.goodsLimit,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "goodsLimit",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "ruleForm.goodsLimit",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("次"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "背景色值：", prop: "bgColor" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入色号，例：“#FFFFFF”" },
                            model: {
                              value: _vm.ruleForm.bgColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "bgColor", $$v)
                              },
                              expression: "ruleForm.bgColor",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "教程下方备注信息：",
                            prop: "remark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入",
                              autosize: "",
                              type: "textarea",
                              maxlength: "512",
                            },
                            model: {
                              value: _vm.ruleForm.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "remark", $$v)
                              },
                              expression: "ruleForm.remark",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间：", prop: "timeArray" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "picker-options": _vm.pickerOptions,
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "default-time": ["00:00:00", "23:59:59"],
                            },
                            model: {
                              value: _vm.ruleForm.timeArray,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "timeArray", $$v)
                              },
                              expression: "ruleForm.timeArray",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#F59A23",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                "请选择活动时间（未选择时间时默认为长期有效状态）"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动规则文案", prop: "ruleTxt" } },
                        [
                          _vm.dialogVisible
                            ? [
                                _c(
                                  "div",
                                  { staticStyle: { border: "1px solid #ccc" } },
                                  [
                                    _c("Toolbar", {
                                      staticStyle: {
                                        "border-bottom": "1px solid #ccc",
                                      },
                                      attrs: {
                                        editor: _vm.editor,
                                        "default-config": _vm.toolbarConfig,
                                        mode: _vm.mode,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("Editor", {
                                      staticStyle: {
                                        height: "250px",
                                        "overflow-y": "hidden",
                                      },
                                      attrs: {
                                        "default-config": _vm.editorConfig,
                                        mode: _vm.mode,
                                      },
                                      on: { onCreated: _vm.onCreated },
                                      model: {
                                        value: _vm.ruleForm.ruleTxt,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "ruleTxt", $$v)
                                        },
                                        expression: "ruleForm.ruleTxt",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("确认")]
                          ),
                          _vm._v(" "),
                          _vm.eventsType === "upDate"
                            ? _c(
                                "el-button",
                                { on: { click: _vm.handleClose } },
                                [_vm._v("关闭")]
                              )
                            : _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.resetForm("ruleForm")
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }